import { CANONICAL_DOMAIN, business } from "../content/site";
import { useLang } from "../i18n/lang";

// React 19 hoista <title>, <meta> y <link> automáticamente al <head>.
// Los scripts JSON-LD permanecen en el body, ubicación igualmente válida para Google.
// `path` es siempre la ruta en español; el canonical y los hreflang se derivan del idioma.
export const SEO = ({ title, description, path = "/", jsonLd = [], image, type = "website" }) => {
  const lang = useLang();
  const esUrl = `${CANONICAL_DOMAIN}${path}`;
  const enUrl = `${CANONICAL_DOMAIN}/en${path}`;
  const url = lang === "en" ? enUrl : esUrl;
  // Variante inglesa de la imagen OG: /og/en/<nombre>.jpg o /og-image-en.jpg
  const toEnVariant = (img) =>
    img.includes("/og/") ? img.replace("/og/", "/og/en/") : `${CANONICAL_DOMAIN}/og-image-en.jpg`;
  const baseImage = image || `${CANONICAL_DOMAIN}/og-image.jpg`;
  const ogImage = lang === "en" ? toEnVariant(baseImage) : baseImage;
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {/* React 19 SSR emite el atributo tal cual; HTML lo parsea case-insensitive,
          por lo que Google lee hreflang correctamente y no hay warning de consola. */}
      <link rel="alternate" hrefLang="es" href={esUrl} />
      <link rel="alternate" hrefLang="en" href={enUrl} />
      <link rel="alternate" hrefLang="x-default" href={esUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={business.brand} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content={lang === "en" ? "en_US" : "es_ES"} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {jsonLd.map((schema, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </>
  );
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${CANONICAL_DOMAIN}${item.path}`,
  })),
});
